import { Column } from "@ant-design/plots";
import { Select, Spin } from "components/common";
import { useEffect, useState } from "react";
import { callGetApiWithAuth } from "utils/api";
import { Wrapper } from "../RankCard.styled";

export default function DailyTECard() {
  const [viewMode, setViewMode] = useState("current");
  const [isLoaded, setIsLoaded] = useState(false);
  const [data, setData] = useState(undefined);
  const [chartData, setChartData] = useState([]);

  const generateMonthlyDates = (year = 2025, month = 5) => {
    const daysInMonth = new Date(year, month, 0).getDate();
    return Array.from({ length: daysInMonth }, (_, i) => ({
      enrollment_date: `${year}-${String(month).padStart(2, "0")}-${String(
        i + 1
      ).padStart(2, "0")}`,
      enrollments: 0,
    }));
  };

  const mergeEnrollmentData = (base, updates) => {
    const updateMap = new Map(
      updates.map((item) => [item.enrollment_date, item.enrollments])
    );
    return base.map((entry) => ({
      ...entry,
      enrollments: updateMap.get(entry.enrollment_date) ?? entry.enrollments,
    }));
  };

  const onGetData = (res) => {
    const responseData = res.data?.data || [];
    setData(res.data);

    const baseChartData = generateMonthlyDates();
    setChartData(mergeEnrollmentData(baseChartData, responseData));

    setIsLoaded(true);
  };

  const onFailedData = () => {
    setIsLoaded(true);
  };

  const loadData = () => {
    setIsLoaded(false);
    if (viewMode == "current") {
      callGetApiWithAuth(
        "home/get_daily_team_enrollments",
        onGetData,
        onFailedData
      );
    } else if (viewMode == "last") {
      callGetApiWithAuth(
        "home/get_daily_team_enrollments_last",
        onGetData,
        onFailedData
      );
    }
  };

  useEffect(() => {
    loadData();
  }, [viewMode]);

  return (
    <Wrapper className="white-rounded-bg">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div className="card-title">
          Daily Team Enrollments (Total: {data?.total ?? 0})
        </div>
        <Select
          value={viewMode}
          onChange={(v) => setViewMode(v)}
          options={[
            {
              label: "Current Month",
              value: "current",
            },
            {
              label: "Last Month",
              value: "last",
            },
          ]}
          style={{ width: "160px" }}
        />
      </div>

      {isLoaded && data && (
        <div className="line-progress-container">
          <Column
            data={chartData}
            xField="enrollment_date"
            yField="enrollments"
            height={300}
          />
        </div>
      )}

      {!isLoaded && (
        <div style={{ height: 300 }}>
          <Spin spinning={true} className="loading-icon" />
        </div>
      )}
    </Wrapper>
  );
}
